import { render, staticRenderFns } from "./TfacInfoCard.vue?vue&type=template&id=14de3af8"
import script from "./TfacInfoCard.vue?vue&type=script&lang=js"
export * from "./TfacInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports